
import { fnLocalizeFilter, ILocale } from "../../../../services/localize.service";
import { IColumn } from "../../../UI/CustomTable/components/Columns/Columns";


interface IGetColumns {
	locale: ILocale;
}

export const getColumns = ( { locale }: IGetColumns ): IColumn[] => {
	return [
		{
			field: 'purseId',
			label: fnLocalizeFilter( locale, '_lang.module.setting.users.titleAccountId' ),
			formatHeader: 'default',
			cell: { format: 'default' },
			align: 'center',
			alignData: 'center'
		},
		{
			field: 'remark',
			label: fnLocalizeFilter( locale, '_lang.module.setting.users.titleAccountRemark' ),
			formatHeader: 'default',
			cell: { format: 'default' },
			align: 'center',
			alignData: 'center'
		},
		{
			field: 'amount',
			label: fnLocalizeFilter( locale, '_lang.module.common.filter.titleBalance' ),
			formatHeader: 'default',
			cell: { format: 'default' },
			align: 'center',
			alignData: 'center'
		}
	]
}
